import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { EditReminderDialogModule } from '../../components/edit-reminder-dialog/edit-reminder-dialog.module';
import { PatientTagComponentModule } from '../../components/patient-tags/patient-tags.module';

import { MatIconModule } from '@angular/material/icon';
import { DocumentsDialogModule  } from '../../components/documents/documents-dialog.module';
import { FamilyPatientsComponent } from './family-patients.component';
import { EditPatientDialogModule } from '../../components/edit-patient-dialog/edit-patient-dialog.module';
import { EditFamilyDialogModule } from '../../components/edit-family-dialog/edit-family-dialog.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';


@NgModule({
    imports: [
        CommonModule,
        DocumentsDialogModule,
        EditPatientDialogModule,
        EditFamilyDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        EditReminderDialogModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        MatSelectModule,
        PatientTagComponentModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        FamilyPatientsComponent
    ],
    exports: [
        FamilyPatientsComponent
    ]
})
export class FamilyPatientsModule { }
